import React, { useEffect, useState } from "react";
import axios from "infra/http";
import { TreeSelect, TreeSelectProps } from "antd";

interface SelectTreeResultadoContatoProps<T> extends TreeSelectProps<T> {
  errorMessage?: string;
}

function SelectTreeResultadoContato({
  errorMessage,
  ...props
}: SelectTreeResultadoContatoProps<any>) {
  const [items, setItems] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);
        const { data } = await axios.get("v1/resultado-cobranca");

        setItems(data);
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  let treeData: any = [];
  items.map((item: any) => {
    return treeData.push({
      title: item.nome,
      value: item.id,
      key: item.id,
      children: item.item,
    });
  });

  const onChange = (
    currentNode: any,
    labelList: React.ReactNode[],
    extra: any
  ) => {
    if (props.onChange !== undefined) {
      props.onChange(currentNode, labelList, extra);
    }
  };

  return (
    <TreeSelect
      {...props}
      showSearch
      style={{
        width: "100%",
        borderColor: errorMessage ? "red" : "transparent",
        borderWidth: errorMessage ? "1px" : "0px",
        borderStyle: "solid",
      }}
      dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
      placeholder="Selecione a categoria"
      allowClear
      treeDefaultExpandAll
      loading={isLoading}
      treeData={treeData}
      size="large"
      onChange={onChange}
    />
  );
}

export default SelectTreeResultadoContato;
